/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { StudentCourseExamViewModel } from "../types/StudentCourseExamViewModel.ts";

export const studentCourseExamViewModelSchema = z.object({
  classroomDisciplineId: z.optional(
    z.number().int().describe("ID da disciplina na sala de aula."),
  ),
  name: z.string().describe("Nome da prova.").nullish(),
  disciplineName: z.string().describe("Nome da disciplina da prova.").nullish(),
  isRecovery: z.optional(
    z.boolean().describe("Indica se a prova é de recuperação."),
  ),
  tryCount: z.optional(
    z
      .number()
      .int()
      .describe("Número de tentativas realizadas pelo aluno nesta prova."),
  ),
  lastTryDate: z
    .string()
    .datetime()
    .describe("Data da última tentativa do aluno nesta prova. Opcional.")
    .nullish(),
  grade: z
    .number()
    .describe("Nota obtida pelo aluno na prova. Opcional.")
    .nullish(),
  mainStartDate: z
    .string()
    .datetime()
    .describe("Data de início da prova principal. Opcional.")
    .nullish(),
  mainEndDate: z
    .string()
    .datetime()
    .describe("Data de término da prova principal. Opcional.")
    .nullish(),
  gradeEditable: z.optional(
    z
      .boolean()
      .describe("Indica se a nota desta prova pode ser editada manualmente."),
  ),
  tries: z
    .array(z.number().int())
    .describe("Lista de IDs das tentativas realizadas pelo aluno nesta prova.")
    .nullish(),
  creationDate: z
    .string()
    .datetime()
    .describe("Data de criação do registro. Opcional.")
    .nullish(),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data da última alteração do registro. Opcional.")
    .nullish(),
  userCreation: z
    .string()
    .describe("Usuário responsável pela criação do registro.")
    .nullish(),
  userLastChange: z
    .string()
    .describe("Usuário responsável pela última alteração do registro.")
    .nullish(),
}) as unknown as ToZod<StudentCourseExamViewModel>;
